import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from './FormSection';

const SECTION_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export default function DetailsSection({
  values,
  onChange,
  errors,
  handleChange,
}) {
  const { t } = useTranslation();
  const tagsArray = Array.isArray(values.tags)
    ? values.tags
    : values.tags
    ? [values.tags]
    : [];
  const [tagsInput, setTagsInput] = useState(tagsArray.join(', '));

  useEffect(() => {
    setTagsInput(tagsArray.join(', '));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tags]);
  return (
    <FormSection
      icon={SECTION_ICON}
      title={t('createAd.titleAndDescription')}
      subtitle={t('createAd.writeTitleDesc')}
    >
      <div className="cf-field">
        <label htmlFor="ad-name">
          {t('createAd.adTitle')} <span className="cf-req">*</span>
        </label>
        <input
          id="ad-name"
          className={`cf-input${errors.name ? ' cf-input--error' : ''}`}
          type="text"
          placeholder={t('createAd.adTitlePlaceholder')}
          name="name"
          maxLength={70}
          value={values.name}
          onChange={handleChange('name')}
        />
        <div className="cf-field-footer">
          <span className="cf-hint">
            {t('createAd.mentionBrand')}
          </span>
          <span className="cf-char-count">{(values.name || '').length}/70</span>
        </div>
        {errors.name && <span className="cf-error">{errors.name}</span>}
      </div>
      <div className="cf-field">
        <label htmlFor="ad-description">
          {t('createAd.description')} <span className="cf-req">*</span>
        </label>
        <textarea
          id="ad-description"
          className={`cf-input cf-textarea${errors.description ? ' cf-input--error' : ''}`}
          name="description"
          placeholder={t('createAd.descriptionPlaceholder')}
          value={values.description}
          onChange={handleChange('description')}
          rows={5}
          maxLength={4096}
        />
        <div className="cf-field-footer">
          <span className="cf-hint">
            {t('createAd.moreDetail')}
          </span>
          <span className="cf-char-count">
            {(values.description || '').length}/4096
          </span>
        </div>
        {errors.description && (
          <span className="cf-error">{errors.description}</span>
        )}
      </div>
      <div className="cf-field">
        <label htmlFor="ad-tags">
          {t('createAd.tags')} <span className="cf-optional">{t('common.optional')}</span>
        </label>
        <input
          id="ad-tags"
          className="cf-input"
          type="text"
          placeholder={t('createAd.tagsPlaceholder')}
          value={tagsInput}
          onChange={(e) => setTagsInput(e.target.value)}
          onBlur={() => {
            // Accept comma, semicolon, or comma+space as separators so that
            // users can type "iphone, 128gb; black" regardless of habit.
            const tags = (tagsInput || '')
              .split(/[,;]/)
              .map((tag) => tag.trim())
              .filter(Boolean);
            onChange('tags', tags);
          }}
        />
        <div className="cf-field-footer">
          <span className="cf-hint">
            {t('ui.tagsHint')}
          </span>
        </div>
      </div>
    </FormSection>
  );
}
